<script lang="ts">
  import { cn, type WithElementRef } from "$lib/utils.js"
  import type { HTMLTableAttributes } from "svelte/elements"

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithElementRef<HTMLTableAttributes> = $props()
</script>

<table bind:this={ref} data-slot="table" class={cn("w-full caption-bottom text-sm", className)} {...restProps}>
  {@render children?.()}
</table>
